import {useState} from 'react'

import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useSearchParams} from '@github-ui/use-navigate'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import {mcpRegistryRoute} from '../mcp-registry-route'

import {Content} from './_components/Content/Content'
import {Header} from './_components/Header/Header'

export function McpRegistry() {
  const payload = useRouteQuery(mcpRegistryRoute, 'mainQuery')
  const isOssV01ApiEnabled = isFeatureEnabled('mcp_registry_oss_v0_1_api')

  const [searchParams, setSearchParams] = useSearchParams()

  // Use 'search' param for v0.1 API, 'q' param for v0 API
  const searchParamKey = isOssV01ApiEnabled ? 'search' : 'q'
  const [searchQuery, setSearchQuery] = useState(searchParams.get(searchParamKey) || '')

  const handleSearchChange = (query: string) => {
    setSearchQuery(query)

    // Update URL search params to trigger server-side search
    const newSearchParams = new URLSearchParams(searchParams)
    if (query.trim()) {
      newSearchParams.set(searchParamKey, query.trim())
    } else {
      newSearchParams.delete(searchParamKey)
    }

    if (isOssV01ApiEnabled) {
      // Reset page when search changes (v0.1 API uses page-based pagination)
      newSearchParams.delete('page')
    } else {
      // Reset cursor and limit when search changes (v0 API uses cursor-based pagination)
      newSearchParams.delete('cursor')
      newSearchParams.delete('limit')
    }

    setSearchParams(newSearchParams, {preventAutofocus: true})
  }

  return (
    <>
      <Header searchQuery={searchQuery} onSearchChange={handleSearchChange} />
      <Content
        key={searchParams.get(searchParamKey) || 'all'}
        data={payload.data.serversData}
        isOssV01ApiEnabled={isOssV01ApiEnabled}
      />
    </>
  )
}

try{ McpRegistry.displayName ||= 'McpRegistry' } catch {}